import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Row from '../../../../../components/Basic/Blocks/Row';
import Button from '../../../../../components/Basic/Buttons/Button';
import H2 from '../../../../../components/Basic/WrapsStyle/H/H2';
import { TYPE_BUTTONS } from '../../../../../constans';

import UserApi from '../../../../../API/user/user-api';
import Column from '../../../../../components/Basic/Blocks/Column';
import PopUp from '../../../../../components/Basic/Blocks/PopUp';
import Input from '../../../../../components/Basic/Inputs/Base';
import DateInput from '../../../../../components/Basic/Inputs/Date';
import InputLabel from '../../../../../components/Basic/Inputs/LabelInput';
import Select from '../../../../../components/Basic/Inputs/Select';
import styles from './styles.module.scss';

const AddHourlyPayPopUp = ({ user = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [day, setDay] = useState(new Date());
  const [name, setName] = useState(user.name);
  const [rate, setRate] = useState();
  const [minutes, setMinutes] = useState();
  const [action, setAction] = useState({ name: '', description: '' });

  let onClickOk = () => {
    UserApi.addExtraWork({
      data: {
        userId: user._id,
        extraWork: { date: day, action_name: action.name, action_description: action.description, minutes: parseInt(minutes), rate: parseInt(rate) },
      }
    }).then((r) => close());
  };

  let disabled_button = false;
  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Добавить почасовую оплату</H2>
      <Input
        value={name}
        label="Имя"
        width="200px"
        onChange={(v) => setName(v)}
        style={{ marginBottom: '15px' }}
        disabled={true}
      />
      <Row>
        <Select
          select={action.name}
          label="Процесс"
          width="250px"
          onSelect={(v) => setAction({ ...action, name: v })}
          list={[
            'Уборка',
            'Разгрузка/подгрузка',
            'Сортировка',
            'Занесение',
            'Разнесение',
            'Такси',
            'Контент',
            'Резервы',
            'Паллеты',
            'Добивка отгрузок',
            'Другое'
          ]}
          style={{ marginRight: '15px' }}
        />
        <Column style={{ marginRight: '10px' }}>
          <InputLabel>Дата</InputLabel>
          <Row style={{ width: '130px' }}>
            <DateInput value={day} className={styles.calendar} onChange={(v) => setDay(new Date(v))} />
          </Row>
        </Column>
      </Row>

      {action.name === 'Другое' &&
        <Row style={{ width: '100%' }}>
          <Input value={action.description} label="Описание процесса" width="95%" onChange={(v) => setAction({ ...action, description: v })} />
        </Row>}
      <Row>
        <Input
          value={minutes}
          label="Количество минут"
          width="200px"
          onChange={(v) => setMinutes(v)}
          style={{ marginRight: '15px' }}
        />
        <Input value={rate} label="Ставка за час" width="200px" onChange={(v) => setRate(v)} />
      </Row>

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          disabled={disabled_button}
          onClick={onClickOk}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default AddHourlyPayPopUp;
